// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {2282: "174f4ea88f1fb656",287: "8def76fe3f44cff2",}[chunkId] + ".css"
}